import { api } from "roboflex-thalamus-request-handler";

export default {

    // OS
    async crudOS(method, payload, id) {
        var url = 'os/ativos-externos'
        if (id) {
            url = url + `/${id}`
        }
        try {
            const response = await api[method](url, payload ?? null)
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },

    // MARCAS
    async crudMarcas(method, payload, id) {
        var url = 'os/ativos-externos/marca'
        if (id) {
            url = url + `/${id}`
        }
        try {
            const response = await api[method](url, payload ?? null)
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },

    // MODELOS
    async crudModelos(method, payload, id) {
        var url = 'os/ativos-externos/modelo'
        if (id) {
            url = url + `/${id}`
        }
        try {
            const response = await api[method](url, payload ?? null)
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },

    // OPERADORAS
    async crudOperadoras(method, payload, id) {
        var url = 'os/ativos-externos/operadora'
        if (id) {
            url = url + `/${id}`
        }
        try {
            const response = await api[method](url, payload ?? null)
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },

    // CLIENTES
    async getClientes() {
        try {
            const response = await api.get('cliente')
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },


    // util
    diasParaFim(status, dtFimPrevisto, dtFimReal) {
        const toLocalDateOnly = (val) => {
            if (!val) return null;

            if (val instanceof Date) {
                return new Date(val.getFullYear(), val.getMonth(), val.getDate());
            }

            if (typeof val === 'string') {
                const s = val.slice(0, 10);
                const [y, m, d] = s.split('-').map(Number);
                if (!y || !m || !d) return null;
                return new Date(y, m - 1, d);
            }

            return null;
        };

        const fimPrevisto = toLocalDateOnly(dtFimPrevisto);
        const fimReal = toLocalDateOnly(dtFimReal);
        const agora = new Date();
        const hoje = new Date(agora.getFullYear(), agora.getMonth(), agora.getDate());

        const st = (status || '').normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase();
        const concluido = st === 'concluido';

        if (concluido) {
            if (!fimPrevisto) return { mensagem: 'Finalizado', cor: 'bg-sucesso' };

            if (!fimReal) return { mensagem: 'Finalizado', cor: 'bg-sucesso' };

            const diffDias = Math.round((fimPrevisto - fimReal) / 86400000);

            if (diffDias > 0) return { mensagem: `Finalizado ${diffDias} dia${diffDias > 1 ? 's' : ''} antes do prazo.`, cor: 'bg-sucesso' };
            if (diffDias === 0) return { mensagem: 'Finalizado no prazo.', cor: 'bg-sucesso' };
            return { mensagem: `Finalizado ${Math.abs(diffDias)} dia${Math.abs(diffDias) > 1 ? 's' : ''} atrasado.`, cor: 'bg-erro' };
        }

        if (!fimPrevisto) return { mensagem: 'Sem Previsão!', cor: 'bg-alerta' };

        const diffDias = Math.round((fimPrevisto - hoje) / 86400000);

        if (diffDias > 0) {
            if (diffDias <= 2) return { mensagem: `${diffDias} dia${diffDias > 1 ? 's restantes!' : ' restante!'}`, cor: 'bg-erro' };
            if (diffDias <= 5) return { mensagem: `${diffDias} dia${diffDias > 1 ? 's restantes!' : ' restante!'}`, cor: 'bg-alerta' };
            return { mensagem: `${diffDias} dia${diffDias > 1 ? 's restantes!' : 'restante!'}`, cor: 'bg-sucesso' };
        } else if (diffDias < 0) {
            return { mensagem: `${Math.abs(diffDias)} dia${Math.abs(diffDias) > 1 ? 's' : ''} de atraso!`, cor: 'bg-erro' };
        } else {
            return { mensagem: 'Hoje!', cor: 'bg-erro' };
        }
    },
}